import update from 'immutability-helper';
import {SET_NEW_SHOPPINGCART} from './actionTypeConsts.js';
import {LEO_THEME} from '../dev.js'
import countryEnum from '../lib/country-enum';

// ------------------------------------
// Constants
// ------------------------------------
export const SET_LEGALADDRESS = 'SET_LEGALADDRESS';
export const SET_SHIPMENTADDRESS = 'SET_SHIPMENTADDRESS';
export const UPDATE_ADDRESSESDIFFER = 'UPDATE_ADDRESSESDIFFER';
export const SET_SHOW_CUSTOMER_ADDRESS_ADDITIONAL_DROPDOWN = 'CUSTOMER_ADDRESS/SET_SHOW_CUSTOMER_ADDRESS_ADDITIONAL_DROPDOWN';
export const SET_CUSTOMER_ADDRESS_ADDITIONAL_DROPDOWN_MANDATORY = 'CUSTOMER_ADDRESS/SET_CUSTOMER_ADDRESS_ADDITIONAL_DROPDOWN_MANDATORY';
export const SET_SHOW_LEGAL_ADDRESS_ADDITIONAL_DROPDOWN = 'LEGAL_ADDRESS/SET_SHOW_LEGAL_ADDRESS_ADDITIONAL_DROPDOWN';
export const SET_SHOW_CUSTOM_SALUTATION_FIELD = 'CUSTOMER_ADDRESS/SET_SHOW_CUSTOM_SALUTATION_FIELD';

export function setShowCustomerAddressAdditionalDropDown(showCustomerAddressAdditionalDropDown) {
	return {
		type: SET_SHOW_CUSTOMER_ADDRESS_ADDITIONAL_DROPDOWN,
		showCustomerAddressAdditionalDropDown,
	};
}

export function setCustomSalutationField(showCustomSalutationField) {
	return {
		type: SET_SHOW_CUSTOM_SALUTATION_FIELD,
		showCustomSalutationField,
	};
}

export function setCustomerAddressAdditionalDropDownMandatory(customerAddressAdditionalDropDownMandatory) {
	return {
		type: SET_CUSTOMER_ADDRESS_ADDITIONAL_DROPDOWN_MANDATORY,
		customerAddressAdditionalDropDownMandatory,
	};
}

export function setShowLegalAddressAdditionalDropDown(showLegalAddressAdditionalDropDown) {
	return {
		type: SET_SHOW_LEGAL_ADDRESS_ADDITIONAL_DROPDOWN,
		showLegalAddressAdditionalDropDown,
	};
}

export function setShipmentAddress(shipmentAddress) {
	return {
		type: SET_SHIPMENTADDRESS,
		shipmentAddress,
	};
}

export function setLegalAddress(legalAddress) {
	return {
		type: SET_LEGALADDRESS,
		legalAddress,
	};
}

export function setAddressesDiffer(addressesDiffer) {
	return {
		type: UPDATE_ADDRESSESDIFFER,
		addressesDiffer,
	};
}

// -------------------
// Action Creators
// -------------------
export function setShipmentAddressOrBothIfSame(shipmentAddress) {
	return (dispatch, getState) => {
		if (!getState().customer.addressesDiffer) {
			const clonedAddress = Object.assign({}, getState().customer.legalAddress, shipmentAddress);
			if (!getState().customer.showLegalAddressAdditionalDropDown) {
				/** if additional info field is hidden, set it to an empty string */
				clonedAddress.additionalInfo = '';
			}
			dispatch(setLegalAddress(clonedAddress));
		}
		return dispatch(setShipmentAddress(shipmentAddress));
	};
}

export function updateShipmentAddress(fieldName, value) {
	return (dispatch, getState) => {
		const updatedAddress =
			Object.assign({}, getState().customer.shipmentAddress, {[fieldName]: value});
		return dispatch(setShipmentAddressOrBothIfSame(updatedAddress));
	};
}

export function updateLegalAddress(fieldName, value) {
	return (dispatch, getState) => {
		const updatedAddress =
			Object.assign({}, getState().customer.legalAddress, {[fieldName]: value});
		return dispatch(setLegalAddress(updatedAddress));
	};
}

export function updateAddressesDiffer(addressesDiffer) {
	return (dispatch, getState) => {
		if (!addressesDiffer) {
			const clonedAddress = Object.assign({}, getState().customer.legalAddress, getState().customer.shipmentAddress);
			if (!getState().customer.showLegalAddressAdditionalDropDown) {
				/** if additional info field is hidden, set it to an empty string */
				clonedAddress.additionalInfo = '';
			}
			dispatch(setLegalAddress(clonedAddress));
		}
		return dispatch(setAddressesDiffer(addressesDiffer));
	};
}

export function setThemeConfigForShipmentAddress() {
	return (dispatch) => {
		// "!!" evaluates to false when there is no value
		const moduleExists = !!(LEO_THEME.modules['customer-address']);
		if (moduleExists) {
			const showCustomerAddressAdditionalDropDown = !!(LEO_THEME.modules['customer-address']['customer-address-additional-dropdown_values']);
			const customerAddressAdditionalDropDownMandatory =
				(LEO_THEME.modules['customer-address']['customer-address-additional-dropdown_mandatory'] === 'true');
			const showLegalAddressAdditionalDropDown =
				!(LEO_THEME.modules['customer-address']['hide-additional-dropdown_billing_address'] === 'true');
			dispatch(setShowCustomerAddressAdditionalDropDown(showCustomerAddressAdditionalDropDown));
			dispatch(setShowLegalAddressAdditionalDropDown(showLegalAddressAdditionalDropDown));
			dispatch(setCustomerAddressAdditionalDropDownMandatory(customerAddressAdditionalDropDownMandatory));
		}
		const addressModuleExists = !!(LEO_THEME.modules['address']);
		const showCustomSalutationField = addressModuleExists && (LEO_THEME.modules['address']['enable-custom-salutation'] === 'true');
		dispatch(setCustomSalutationField(showCustomSalutationField));
		return Promise.resolve();
	};
}

export function getCountryCodeFromTheme() {
	const defaultCountyCode = 'DE'
	const existingCountryCodes = Object.keys(countryEnum)
	const moduleExists = !!(LEO_THEME.modules['address']);
	if (moduleExists) {
		const propExists = !!(LEO_THEME.modules['address']['default-country-code']) && existingCountryCodes.indexOf(LEO_THEME.modules['address']['default-country-code']) > -1
		return propExists ? (LEO_THEME.modules['address']['default-country-code']) : defaultCountyCode;
	}
	return defaultCountyCode
}

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
	shipmentAddress: {
		countryCode: getCountryCodeFromTheme(),
		salutation: '',
		customSalutation: '',
		firstname: '',
		lastname: '',
		companyName: '',
		additionalInfo: '',
		email: '',
		postalCode: '',
		city: '',
		street: '',
		houseNumber: '',
		phoneNumber: '',
	},
	legalAddress: {
		countryCode: getCountryCodeFromTheme(),
		salutation: '',
		customSalutation: '',
		firstname: '',
		lastname: '',
		companyName: '',
		additionalInfo: '',
		email: '',
		postalCode: '',
		city: '',
		street: '',
		houseNumber: '',
		phoneNumber: '',
		marketingApproval: false,
	},
	addressesDiffer: false,
	showCustomerAddressAdditionalDropDown: false,
	showLegalAddressAdditionalDropDown: true,
	customerAddressAdditionalDropDownMandatory: false,
	showCustomSalutationField: false
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[SET_SHIPMENTADDRESS]: (state, action) => update(state, {
		shipmentAddress: {$set: action.shipmentAddress},
	}),
	[SET_LEGALADDRESS]: (state, action) => update(state, {
		legalAddress: {$set: action.legalAddress},
	}),
	[UPDATE_ADDRESSESDIFFER]: (state, action) => update(state, {
		addressesDiffer: {$set: action.addressesDiffer},
	}),
	[SET_SHOW_CUSTOMER_ADDRESS_ADDITIONAL_DROPDOWN]: (state, action) => update(state, {
		showCustomerAddressAdditionalDropDown: {$set: action.showCustomerAddressAdditionalDropDown},
	}),
	[SET_SHOW_LEGAL_ADDRESS_ADDITIONAL_DROPDOWN]: (state, action) => update(state, {
		showLegalAddressAdditionalDropDown: {$set: action.showLegalAddressAdditionalDropDown},
	}),
	[SET_CUSTOMER_ADDRESS_ADDITIONAL_DROPDOWN_MANDATORY]: (state, action) => update(state, {
		customerAddressAdditionalDropDownMandatory: {$set: action.customerAddressAdditionalDropDownMandatory},
	}),
	[SET_SHOW_CUSTOM_SALUTATION_FIELD]: (state, action) => update(state, {
		showCustomSalutationField: {$set: action.showCustomSalutationField},
	}),
	[SET_NEW_SHOPPINGCART]: () => initialState,
};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
